module.exports = __webpack_public_path__ + "632c488269d679d1325801db34afb522.png";